module.exports = __webpack_public_path__ + "img/favicon.fe3c40de.png";